(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const navItems = document.querySelectorAll('.featured-collection-slider__navigation-list-item');
  const panels = document.querySelectorAll('.tab-panel');
  const arrowSets = document.querySelectorAll('.carousel__navigation-buttons');
  const swipers = new Map(); // Store Swiper instances

  navItems.forEach((item, idx) => {
    item.addEventListener('click', () => {
      // Update active states
      navItems.forEach(i => i.classList.remove('selected'));
      item.classList.add('selected');
      panels.forEach(p => p.classList.remove('active'));
      panels[idx].classList.add('active');
      arrowSets.forEach(a => a.classList.remove('visible'));
      arrowSets[idx].classList.add('visible');

      // Initialize Swiper if not already done
      const swiperEl = panels[idx].querySelector('.swiper');
      if (swiperEl && !swipers.has(swiperEl)) {
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 20,
          loop: false,
          navigation: {
            nextEl: arrowSets[idx].querySelector('[data-next]'),
            prevEl: arrowSets[idx].querySelector('[data-prev]'),
          },
          pagination: {
            el: swiperEl.querySelector('.swiper-pagination'),
            clickable: true,
          },
          breakpoints: {
            480: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          },
        });
        swipers.set(swiperEl, swiper);
      }
    });
  });

  // Initialize first tab on load
  if (panels.length > 0) {
    const firstSwiperEl = panels[0].querySelector('.swiper');
    if (firstSwiperEl) {
      const swiper = new Swiper(firstSwiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 20,
        loop: false,
        navigation: {
          nextEl: arrowSets[0].querySelector('[data-next]'),
          prevEl: arrowSets[0].querySelector('[data-prev]'),
        },
        pagination: {
          el: firstSwiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          480: { slidesPerView: 2 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
        },
      });
      swipers.set(firstSwiperEl, swiper);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  var sections = document.querySelectorAll('.featured-collection-slider');

  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('.featured-collection-slider__navigation-list-item');
    var contents = section.querySelectorAll('.featured-collection-slider__content');
    var swipers = [];

    // Swiper Init
    contents.forEach(function (content, index) {
      var swiperInstance = new Swiper(".featured-collection-swiper-" + index, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        breakpoints: {
          0: { slidesPerView: 2, spaceBetween: 10 },
          768: { slidesPerView: 3, spaceBetween: 15 },
          1024: { slidesPerView: 4, spaceBetween: 20 }
        }
      });
      swipers[index] = swiperInstance;
    });

    // Tabs switching
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var index = parseInt(tab.getAttribute("data-navigation-item"));

        tabs.forEach(t => t.classList.remove("selected"));
        contents.forEach(c => { c.classList.remove("visible"); c.style.display = "none"; });

        tab.classList.add("selected");
        contents[index].classList.add("visible");
        contents[index].style.display = "block";

        if (swipers[index]) {
          setTimeout(() => swipers[index].update(), 50);
        }
      });
    });

  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  var sections = document.querySelectorAll('.featured-collection-slider');

  sections.forEach(function (section) {
    var tabs = section.querySelectorAll('.featured-collection-slider__navigation-list-item');
    var contents = section.querySelectorAll('.featured-collection-slider__content');
    var swipers = [];

    // Initialize Swipers for each collection
    contents.forEach(function (content, index) {
      var swiperInstance = new Swiper(".featured-collection-swiper-" + index, {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: false,
        navigation: false,
        pagination: false,
        breakpoints: {
          0: { 
            slidesPerView: 2,
            spaceBetween: 10 
          },
          768: { 
            slidesPerView: 3,
            spaceBetween: 15 
          },
          1024: { 
            slidesPerView: 4,
            spaceBetween: 20 
          }
        }
      });
      
      swipers[index] = swiperInstance;
    });

    // Tab Switching Logic
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var index = parseInt(tab.getAttribute("data-navigation-item"));

        // Remove selected class from all tabs
        tabs.forEach(function(t) {
          t.classList.remove("selected");
        });

        // Hide all content sections
        contents.forEach(function(c) {
          c.classList.remove("visible");
          c.style.display = "none";
        });

        // Add selected class to clicked tab
        tab.classList.add("selected");
        
        // Show corresponding content
        if (contents[index]) {
          contents[index].classList.add("visible");
          contents[index].style.display = "block";
          
          // Update swiper after visibility change
          if (swipers[index]) {
            setTimeout(function() {
              swipers[index].update();
            }, 50);
          }
        }
      });
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
